import React from 'react';
import dynamic from 'next/dynamic';
import HeaderLogo from 'components/commercetools-ui/organisms/header/header-logo';
import HeaderNavigationDesktop from 'components/commercetools-ui/organisms/header/header-navigation/header-navigation-desktop';
import HeaderNavigationMobile from 'components/commercetools-ui/organisms/header/header-navigation/header-navigation-mobile';
import { HeaderProps } from 'components/commercetools-ui/organisms/header/types';
import UtilitySection from 'components/commercetools-ui/organisms/header/utility-section';

const CommercetoolsSearch = dynamic(() => import('components/commercetools-ui/atoms/search'));

const Header: React.FC<Omit<HeaderProps, 'announcementBars'>> = ({
  cart,
  isEmpty,
  onRemoveDiscountCode,
  onApplyDiscountCode,
  totalCartItems,
  onRemoveItem,
  onUpdateItem,
  navLinks,
  categories,
  logo,
  logoMobile,
  logoLink,
  logoLinkMobile,
  tiles,
  searchItems,
  onSearchQueryUpdate,
  isProductSearchLoading,
  emptyCartTitle,
  emptyCartSubtitle,
  emptyCartCategories,
  sideCartPaymentMethods,
  enableNavigationTitleButton,
  navigationTitleButtonLabel,
  navigationTitleButtonLink,
}) => {
  const Search = CommercetoolsSearch;

  return (
    <header className="relative h-fit w-full border-b-[1.5px] border-stroke-primary bg-white">
      <div aria-label="Top" className="container relative flex w-full items-center justify-between py-16">
        <HeaderNavigationMobile
          logo={logoMobile}
          links={navLinks}
          logoLink={logoLinkMobile}
          navigationTitleButtonEnabled={enableNavigationTitleButton}
          navigationTitleButtonLabel={navigationTitleButtonLabel}
          navigationTitleButtonLink={navigationTitleButtonLink}
        />

        <div className="ml-0 flex w-full justify-center lg:ml-0 lg:w-fit">
          <HeaderLogo
            logo={logo}
            logoLink={logoLink}
            imageClassName="flex h-46 w-115 md:w-150 justify-center text-center text-16 font-bold md:text-28"
          />
        </div>

        <div className="relative hidden w-full px-16 md:px-32 lg:block lg:w-full lg:px-20">
          <Search
            isProductSearchLoading={isProductSearchLoading}
            categories={categories}
            items={searchItems}
            onQueryUpdate={onSearchQueryUpdate}
          />
        </div>

        <UtilitySection
          cart={cart}
          onRemoveDiscountCode={onRemoveDiscountCode}
          onApplyDiscountCode={onApplyDiscountCode}
          isEmpty={isEmpty}
          onRemoveItem={onRemoveItem}
          onUpdateItem={onUpdateItem}
          totalCartItems={totalCartItems}
          emptyCartTitle={emptyCartTitle}
          emptyCartSubtitle={emptyCartSubtitle}
          emptyCartCategories={emptyCartCategories}
          sideCartPaymentMethods={sideCartPaymentMethods}
        />
      </div>

      <div className="container relative block w-full border-t-2 border-stroke-primary py-13 lg:hidden">
        <Search categories={categories} items={searchItems} onQueryUpdate={onSearchQueryUpdate} />
      </div>

      <HeaderNavigationDesktop
        links={navLinks}
        tiles={tiles ?? []}
        navigationTitleButtonEnabled={enableNavigationTitleButton}
        navigationTitleButtonLabel={navigationTitleButtonLabel}
        navigationTitleButtonLink={navigationTitleButtonLink}
      />
    </header>
  );
};

export default Header;
